import { useQuery } from '@tanstack/react-query';
import { fetch_fee_preview } from './api';

/**
 * The fee for a category, cached per category rather than per keystroke.
 *
 * The price is deliberately NOT part of the query: the rate does not depend on it,
 * so the arithmetic is done in the component and typing a price costs no requests.
 */
export function use_fee_preview(vertical: 'FOOD' | 'PHARMACY', category: string | undefined) {
  return useQuery({
    queryKey: ['fee-preview', vertical, category],
    queryFn: () => fetch_fee_preview({ vertical, category: category as string }),
    enabled: !!category,
    staleTime: 5 * 60_000,
  });
}
